export const dbs = {
  namespaced: true,
  state: {
    park: null,
    cycle: null,
    reservation: null,
    reports: [],
    myCouponTickets: [],
  },
  getters: {
    park(state) {
      return state.park;
    },
    cycle(state) {
      return state.cycle;
    },
    reservation(state) {
      return state.reservation;
    },
    reports(state) {
      return state.reports;
    },
    myCouponTickets(state) {
      return state.myCouponTickets;
    },
  },
  mutations: {
    setPark(state, park) {
      state.park = park;
    },
    setCycle(state, cycle) {
      state.cycle = cycle;
    },
    setReservation(state, reservation) {
      state.reservation = reservation;
    },
    setReports(state, reports) {
      state.reports = reports;
    },
    setMyCouponTickets(state, myCouponTickets) {
      state.myCouponTickets = myCouponTickets;
    },
  },
};
